export const pmsNameOptions = [
    { value: 'cloud-9', label: 'Cloud 9' },
    { value: 'denticon', label: 'Denticon' },
    { value: 'dentrix-ascend', label: 'Dentrix Ascend' },
    { value: 'open-dental', label: 'Open Dental' }
];

// Saved PMS names may be dropdown slugs, display labels, or API names such as OpenDental.
export const normalizePmsName = (pmsName: string): string => {
    const normalizedName = pmsName.trim().toLowerCase().replace(/[\s-]/g, '');
    const matchedOption = pmsNameOptions.find(option =>
        option.value.replace(/-/g, '') === normalizedName
    );
    return matchedOption ? matchedOption.value : pmsName;
};
